import Store from '@/store';
import { CurrenciesPluginService } from '@/services/common/currencies.service';

export const currenciesPlugin = {
  install(vue: any) {
    vue.prototype.$currency = new CurrenciesPluginService(Store);
  },
};
